$(document).ready(function () {
    $("#hero-banner").each(function () {
        var bgColor = $(this).data("background-color");
        if (bgColor) {
            $(this).css({
                "background-color": bgColor,
            });
        }
    });
});